import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Box } from "@chakra-ui/react";
import { CloseCircleIcon } from "../../../../components/icons/CloseCircleIcon";
import { CaretDownIcon } from "../../../../components/icons/CaretDownIcon";
import { cloneElement, useState } from "react";

interface FilterAdapter { value: any; onChange: (value: any) => void; }

function hasActiveFilter(adapter?: FilterAdapter): boolean {
  if (!adapter) return false;
  const v = adapter.value;
  if (Array.isArray(v)) return v.length > 0;
  // "0" is the "All" value for radio filters (e.g. type, format) — treat as inactive
  if (typeof v === "string") return v !== "" && v !== "0" && v !== undefined;
  return !!v;
}

interface BrowseFiltersAccordionProps { filters: any[]; }
export function BrowseFiltersAccordion({ filters }: BrowseFiltersAccordionProps) {
  const validFilters = filters.filter((n) => !!n);
  const [expandedIndices, setExpandedIndices] = useState<number[]>(() =>
    validFilters.map((group, i) => hasActiveFilter(group[2] as FilterAdapter | undefined) ? i : -1).filter((i) => i >= 0),
  );

  return (
    <Accordion allowMultiple index={expandedIndices} onChange={(indices) => {
      const next = indices as number[];
      const forced = expandedIndices.filter((i) => {
        const adapter = validFilters[i]?.[2] as FilterAdapter | undefined;
        return hasActiveFilter(adapter) && !next.includes(i);
      });
      setExpandedIndices([...new Set([...next, ...forced])]);
    }} borderRadius={4} variant="filterList">
      {validFilters.map((group, index) => {
        const [title, filter, adapter] = group;
        const isExpanded = expandedIndices.includes(index);
        return (
          <AccordionItem key={index}>
            <>
              <AccordionButton>
                {cloneElement(title, { open: isExpanded })}
                {isExpanded ? (
                  <Box as="span" onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    if (adapter) { const a = adapter as FilterAdapter; a.onChange(Array.isArray(a.value) ? [] : "0"); }
                    setExpandedIndices((prev) => prev.filter((i) => i !== index));
                  }}>
                    <CloseCircleIcon boxSize="20px" color="blaze.300" />
                  </Box>
                ) : <CaretDownIcon boxSize="20px" color="neutral.400" />}
              </AccordionButton>
              <AccordionPanel>{filter}</AccordionPanel>
            </>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}
